export const CARRIER_ID = 'de175f0e-6545-4fc0-ad70-43179cec5318'
export const SSO_URL = 'https://sso.rotate.group/'
export const CHECK_WX_API_KEY = '5f834ed10513dd66e5d3850fb5'
export const CARRIER_CALLSIGN = 'AA'
export const MAPBOX_URI =
  'https://api.mapbox.com/styles/v1/edwinbrowwn/cl8fd49xd003m15rti3mhdi1o/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZWR3aW5icm93d24iLCJhIjoiY2trcWs0YWZjMDg0bzJ1cXQyODB1NnNydSJ9.tlLwEw7sB5aNaHxQTpqkRw'
export let API_URL =
  process.env.NODE_ENV === 'development'
    ? //'http://localhost:8787/'
      'https://api-v2.rotate.group/'
    : 'https://api-v2.rotate.group/'

export const socialLinks = [
  {
    title: 'discord',
    link: 'https://discord.gg/KU2utP4M2B',
  }
]
